module.exports = "dist/logo_police.png?6b4b03f97dc4be9567d7d6669318de8c";